var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notification-bar"},[_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":_vm.icon}}),(_vm.message)?_c('div',{staticClass:"message"},[_vm._v(_vm._s(_vm.message))]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }